import { css } from "emotion";
import { Component } from "preact";

const min = len => `@media (min-width: ${len}px)`;
const max = len => `@media (max-width: ${len}px)`;

const stepItem = css({
  a: {
    color: "#323232",
    fontSize: 16
  },
  // css for screen width <700px
  [max(700)]: {
    ":not(:first-of-type)": {
      "::before": {
        content: `''`,
        display: "inline-block",
        width: 7,
        height: 7,
        margin: "0px 7px 2px 8.6px",
        borderTop: "2px solid #788391",
        borderRight: "2px solid #788391",
        backgroundColor: "white",
        transform: "rotate(45deg)"
      }
    },
    display: "inline-block",
    "#step-desktop": {
      display: "none"
    },
    "#step-mobile": {
      display: "inline-block"
    }
  },
  // css for screen width >700px
  [min(700)]: {
    "&::before": {
      content: `counter(li)`,
      width: 24,
      height: 24,
      marginRight: 4,
      display: "inline-block",
      color: "white",
      borderRadius: "100%",
      lineHeight: "23px",
      backgroundColor: "#323232"
    },
    "&::after": {
      content: `''`,
      backgroundColor: "#dedede",
      verticalAlign: "middle",
      position: "relative",
      left: 8,
      width: 20,
      height: 1,
      marginRight: 16,
      display: "inline-block"
    },
    ":last-child": {
      ":after": {
        display: "none"
      }
    },
    counterIncrement: "li",
    display: "inline-block"
  }
});

const processSteps = css({
  margin: "auto",
  paddingTop: 24,
  paddingBottom: 24,
  textAlign: "center"
});

const wrapper = css({
  marginBottom: 20,
  marginRight: "auto",
  marginLeft: "auto",
  marginTop: 8,
  boxShadow: "0 0 1px 0 #f1f1f1, 0 1px 3px 0 rgba(9, 30, 66, 0.13)",
  [max(700)]: {
    marginTop: 0,
    marginBottom: 8
  }
});

const desktopLabel = css({
  display: "inline-block",
  [max(700)]: {
    display: "none"
  }
});

const mobileLabel = css({
  display: "none",
  [max(700)]: {
    display: "inline-block"
  }
});

const defaultStyle = css({
  "&::before": {
    backgroundColor: "#A4A9A4"
  }
});

const finished = css({
  "&::before": {
    backgroundColor: "#6621c0"
  }
});

const active = css({
  "&::before": {
    backgroundColor: "#6621c0"
  },
  fontWeight: "600",
  a: {
    color: "#6621c0"
  }
});

class Steps extends Component {
  constructor(props) {
    super(props);
  }

  render({ page }) {
    let steps = [
      {
        label: "Buyer Details",
        mobileLabel: "Buyer Details"
      },
      {
        label: `Ticket Information`,
        mobileLabel: "Ticket Information"
      }
    ];

    return (
      <div className={wrapper}>
        <ul className={processSteps}>
          {steps.map((step, index) => {
            const classes = [stepItem];
            if (index === page) {
              classes.push(active);
            } else if (page > index) {
              classes.push(finished);
            } else {
              classes.push(defaultStyle);
            }
            return (
              <li key={index} className={css(classes)}>
                <div style={{ display: "inherit" }}>
                  <div className={desktopLabel}>{step.label}</div>
                  <div className={mobileLabel}>{step.mobileLabel}</div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
export default Steps;



// WEBPACK FOOTER //
// ./routes/public/editOrder/Steps.js